import React from 'react';
import { FolderInput, Brain, GitBranch, Upload } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Drop your intake folder',
    body:
      'Point Sortio at any folder of loose documents: scanned intake stacks, downloaded e-filings, email attachments, settlement drafts. Sortio indexes them on your Mac and classifies with the AI you choose: our cloud by default, your own key, or fully local with Ollama.',
  },
  {
    icon: Brain,
    title: 'Classify by content',
    body:
      'Sortio reads each file (PDFs, Word docs, JPGs, audio transcripts) and extracts client name, opposing party, document type, dates, matter ID, and case caption. Files are tagged as contracts, correspondence, pleadings, discovery, invoices, or your own custom buckets.',
  },
  {
    icon: GitBranch,
    title: 'Route to the right matter',
    body:
      'Each file is assigned to a client matter based on the entities Sortio extracted. You see a confidence score for every assignment and can override anything in the preview screen before files move. Privileged docs flagged for review stay quarantined until an attorney releases them.',
  },
  {
    icon: Upload,
    title: 'File locally or to Clio',
    body:
      'Approved files land in the right Mac folder, or upload directly into Clio Manage when the integration is connected. Every operation is audit-logged with timestamp, source path, destination matter, and which user approved it.',
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How matter-based filing works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a folder of loose intake to clean, matter-organized documents you can hand
          to a partner or upload to Clio.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div
              key={i}
              className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col"
            >
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">
                  Step {i + 1}
                </span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
